import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';

import moment from 'moment';

import { connect } from 'react-redux';
import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS } = helpers;

import PlusIcon from '../../assets/icons/plus';
import ArrowIcon from '../../assets/icons/arrow-indent-right';
import EmptyArea from 'components/EmptyArea/EmptyArea';

import { keyedObjToArr, formatPrice , getOrderPrice, getOrderStudents } from '../util';

class OrderListPanel extends Component{

	constructor(props) {
		super(props);
	}

	addOrder () {
		console.log("TODO");
	}

	render (){
		if(!isLoaded(this.props.orders)){
			return false;
		}

		let customerOrders = this.props.customer.orders ? keyedObjToArr(this.props.customer.orders).map( (order)=>{
			return this.props.orders[order.id];
		}) : [];

		return (<div>
			{this.props.customer.orders ? (
				<div className="ui-list tight">
					<div className="header-container">
							<div className="list-row header" key="header">'
								<div className="list-cell no-grow"></div>
								<div className="list-cell wide"><span className="data">Products</span></div>
								<div className="list-cell"><span className="data">Price</span></div>
								<div className="list-cell qty align-right"><span className="data">Students</span></div>
							</div>
						</div>

					{customerOrders.map( (order, index)=> {
						let price = getOrderPrice(order);
						let students = getOrderStudents(order);
						return(
							<div key={index} className="list-row">
								<div className="list-cell no-grow"> <span className={'status ' + order.status}></span> </div>
								<div className="list-cell wide">
									<div>{order.title}</div>
									<div>{ order.products ? keyedObjToArr(order.products).map( (product, index) => {
										return(<span key={index}>{product.name}</span>);
									}) : false }</div>
								</div>
								<div className="list-cell">
									<div>{formatPrice(price.total)}</div>
									<div>{this.props.endDate ? moment(this.props.endDate).format('MM/DD/YYYY') : false }</div>
								</div>
								<div className="list-cell qty align-right"><span className="data">{students}</span></div>
							</div>
						);
					})}

				</div>
			) : <span>No orders found.</span> }
		</div>);
	}
}

const fbWrappedComponent = firebaseConnect([
	'/orders',
])(OrderListPanel);

export default connect(
	({ firebase }) => ({
		orders: dataToJS(firebase, 'orders')
	}),
	null
)(fbWrappedComponent);



// WEBPACK FOOTER //
// ./js/components/OrderListPanel.js